import { Action } from "redux";

export const APP_INIT_SUCCESS_ACTION = "COMMON:APP_INIT_SUCCESS_ACTION";

export interface AppInitSuccessAction extends Action {
  type: typeof APP_INIT_SUCCESS_ACTION;
}

export const appInitSuccessAction = (): AppInitSuccessAction => ({
  type: APP_INIT_SUCCESS_ACTION,
});
